import { CUBE_COMPONENT_TYPE_ATTRIBUTE, CUBE_COMPONENT_TYPE_DIMENSION, CUBE_COMPONENT_TYPE_MEASURE, CUBE_COMPONENT_TYPE_TIME_DIMENSION } from "./constants";

export const getMappingIcon = (mappingId) => {   
    const iconType = mappingId === -1 
    ? "plus" 
    : "retweet";       
    return iconType;
};

export const createMappingComponents = (currentMapping, csvHeader, cubeComponents) => {

    const components = [];
    (currentMapping.Components || []).forEach(mapping => {
        let component;
        if (csvHeader.some(column => column === mapping.ColumnName)) {
            switch (mapping.CubeComponentType) {
                case CUBE_COMPONENT_TYPE_TIME_DIMENSION:
                    component = cubeComponents.timeDimensions;
                    break;
                case CUBE_COMPONENT_TYPE_ATTRIBUTE:
                    component = cubeComponents.attributes.concat(cubeComponents.tidAttributes);
                    break;
                case CUBE_COMPONENT_TYPE_MEASURE:
                    component = cubeComponents.measures;
                    break;
                case CUBE_COMPONENT_TYPE_DIMENSION:
                default:
                    component = cubeComponents.dimensions;
                    break;
            }

            if (component.some(c => c.Code === mapping.CubeComponentCode)) {
                components.push(
                    {
                        columnName: mapping.ColumnName,
                        cubeComponentCode: mapping.CubeComponentCode,
                        cubeComponentType: mapping.CubeComponentType,
                        idMapping: mapping.IDMapping,
                        mappingType: mapping.MappingType
                    }
                );
            }
        }        
    });

    return components;
}

export const mappingIsValid = (mappingComponents, cubeComponents) => {
    
    for(let i = 0; i < (cubeComponents.dimensions || []).length; i++ ) {
        const code = cubeComponents.dimensions[i].Code;
        const componentisMapped =  (mappingComponents || []).some(
            c => c.cubeComponentCode === code && c.cubeComponentType === CUBE_COMPONENT_TYPE_DIMENSION
        );
        if (!componentisMapped) {
            return false;
        }     
    }
    for(let i = 0; i < (cubeComponents.timeDimensions || []).length; i++ ) {
        const code = cubeComponents.timeDimensions[i].Code;
        const componentisMapped =  (mappingComponents || []).some(
            c => c.cubeComponentCode === code && c.cubeComponentType === CUBE_COMPONENT_TYPE_TIME_DIMENSION
        );
        if (!componentisMapped) {
            return false;
        }     
    }
    for(let i = 0; i < (cubeComponents.measures || []).length; i++ ) {
        const code = cubeComponents.measures[i].Code;
        const componentisMapped =  (mappingComponents || []).some(
            c => c.cubeComponentCode === code && c.cubeComponentType === CUBE_COMPONENT_TYPE_MEASURE
        );
        if (!componentisMapped) {
            return false;
        }     
    }
    let mandatoryAttributes = (cubeComponents.attributes || []).filter(a => a.IsMandatory === true);
    let mandatoryTidAttributes = (cubeComponents.tidAttributes || []).filter(a => a.IsMandatory === true);
    const attributes = mandatoryAttributes.concat(mandatoryTidAttributes)
    for(let i = 0; i < (attributes || []).length; i++ ) {
        const code = attributes[i].Code;
        const componentisMapped =  (mappingComponents || []).some(
            c => c.cubeComponentCode === code && c.cubeComponentType === CUBE_COMPONENT_TYPE_ATTRIBUTE
        );
        if (!componentisMapped) {
            return false;
        }     
    }

    return true;
}



// WEBPACK FOOTER //
// ./src/components/easy-loading/mapping-step/utils.js